import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import General from "./Tabs/General";
import Participants from "./Tabs/Participants";
import { useDispatch, useSelector } from "react-redux";
import {
  epochToDateObject,
  formatDateTimeRangeFromServer,
  moveBack,
  serverFormatToDateString,
} from "../../../../system";
import moment from "moment";
import { EventActions, SpotActions } from "../../../../redux/actions";
import {
  Directions,
  timezoneConstants,
  translationConstants,
} from "../../../../constants";
import BTN_BACK from "../../../../assets/images/icon/arrow-left.svg";

const Event = () => {
  const { t } = useTranslation();
  const [key, setKey] = useState("general");
  const dispatch = useDispatch();
  const queryParameters = new URLSearchParams(window.location.search);
  const eventId = queryParameters.get("eventId");
  const eventData = useSelector((state) => state.eventReducer.eventDataById);
  const totalPaymentData = useSelector(
    (state) => state.eventReducer.eventTotalPaymentById
  );
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  useEffect(() => {
    dispatch(EventActions.getEventById(eventId));
    dispatch(EventActions.getEventTotalPaymentById(eventId));
    //eslint-disable-next-line
  }, [eventId]);

  return (
    <div className="UserDiv pe-md-2">
      {eventData && (
        <div>
          <div className="d-md-flex justify-content-between">
            <div>
              <p className="UserTabHeading">
                <span className="cursor-pointer px-2" onClick={moveBack}>
                  <img src={BTN_BACK} className="rotated-element" />
                </span>
                {direction === Directions.rtl
                  ? eventData?.arabicTitle
                    ? eventData?.arabicTitle
                    : eventData?.title
                  : eventData?.title}
              </p>
              <p className="UserTabSubHeading">
                {formatDateTimeRangeFromServer(
                  eventData?.startDateString,
                  eventData?.endDateString,
                  timezoneConstants.dayMonthYearFormat
                )}
              </p>
            </div>
            {eventData?.isPublicRegistrationAllowed && (
              <div>
                <p className="UserTabHeading text-md-end">
                  {t(translationConstants.totalPayment)}
                </p>
                <p className="UserTabSubHeading font-25 text-black text-md-end">
                  {translationConstants.SAR}{" "}
                  {totalPaymentData?.totalPayment?.toFixed(2) || 0}
                </p>
              </div>
            )}
          </div>

          <div className="tabsDiv ">
            <div>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className=""
              >
                <Tab eventKey="general" title={t("general")}>
                  {key === "general" && <General eventData={eventData} />}
                </Tab>
                <Tab
                  eventKey="participants"
                  title={t(translationConstants.participant)}
                >
                  {key === "participants" && (
                    <Participants eventData={eventData} />
                  )}
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Event;
